<template>
  <div class="uestion_wrap">
    <ul class>
      <li
        class="fs20"
        v-for="(item,index) in uestionList"
        :key="index"
      >
        <!-- @click.stop="clickUest(index)" -->
        <div
          @click.stop="clickUest(index)"
          style="cursor: pointer;"
        >
          <i
            style="cursor: pointer;"
            class="el-icon-arrow-right uestion_li_icon fwb"
            :class="item.open?'is-active':''"
          ></i>
          {{item.title}}
        </div>
        <transition name="el-zoom-in-center">
          <div
            class="uestion_li_text c_666 fs16"
            v-show="item.open"
            v-html="item.content"
          ></div>
        </transition>
      </li>
    </ul>
    <div
      class="margin-top pager_box"
      v-if="showAll"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        :total="17"
        :page-size="7"
        @current-change="changeInfo"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import uestionjson from "@/json/uestionjson.json";
export default {
  props: {
    showAll: {
      type: Boolean,
      default: true,
      clickLog: false
    },
  },
  data () {
    return {
      uestionList: [],
      currentIndex: 1
    };
  },
  created () {
    uestionjson.forEach((item) => {
      item.open = false;
    });
    if (this.showAll) {
      this.getInfo();
    } else {
      this.uestionList = uestionjson.filter((item, index) => {
        return index < 3;
      });
    }
  },
  methods: {

    getInfo () {
      let star = this.currentIndex == 1 ? 0 : (this.currentIndex - 1) * 7
      let end = Number(this.currentIndex) * 7 - 1;
      this.uestionList = uestionjson.filter((item, index) => {
        return end >= index && index >= star;
      });
    },
    clickUest (i) {
      if (this.clickLog) return;
      this.clickLog = true;
      this.uestionList[i].open = !this.uestionList[i].open;
      setTimeout(() => {
        this.clickLog = false;
      }, 300);
    },
    changeInfo (e) {
      this.currentIndex = e;
      this.getInfo();
    }
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/uestion/index.vue